/*
 * Copyright (c) 2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import {Nodes} from "../Objects/Nodes.jsx";
import Console from "./Console.jsx";

class DisplayNodeInstallLog extends Component {
    constructor() {
        super();
        this.state = {
            logs: []
        }
    }

    async fetchData() {
        let {nodeId} = this.props
        let result = await Nodes(nodeId).getInstallLog()
        if (!result.hasOwnProperty("error")) {
            this.setState({logs: (result).split("\n")})
        }

    }

    componentDidMount() {
        this.fetchData()
        this.interval = setInterval(() => {
            this.fetchData()
        }, 10000)
    }

    componentWillUnmount() {
        clearInterval(this.interval)
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.nodeId !== this.props.nodeId) {
            this.fetchData()
        }
    }


    render() {

        return (
            <div className={" w-full"}>
                <Console logs={this.state.logs} titel={"Install log"}/>
            </div>
        );
    }
}

DisplayNodeInstallLog.propTypes = {};

DisplayNodeInstallLog.defaultProps = {};


export default DisplayNodeInstallLog;